export default "__VITE_ASSET__c23Kpgbe__"